import { render, staticRenderFns } from "./TurnieranmeldungExpress.vue?vue&type=template&id=5024e304&scoped=true&"
import script from "./TurnieranmeldungExpress.vue?vue&type=script&lang=js&"
export * from "./TurnieranmeldungExpress.vue?vue&type=script&lang=js&"
import style0 from "./TurnieranmeldungExpress.vue?vue&type=style&index=0&id=5024e304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024e304",
  null
  
)

export default component.exports